import React, { lazy } from 'react';
import ChoosePack from 'components/_steps/ChoosePack/ChoosePack';
import SummaryActions from 'components/_steps/BikeSummary/SummaryActions/SummaryActions';

const ChooseColour = lazy(() => import('components/_steps/ChooseColour/ChooseColour'));
// const ChoosePack = lazy(() => import('components/_steps/ChoosePack/ChoosePack'));
const ChooseAccessories = lazy(() => import('components/_steps/ChooseAccessories/ChooseAccessories'));
const BikeSummary = lazy(() => import('components/_steps/BikeSummary/BikeSummary'));

const steps = [
  {
    label: 'bikeLabel',
    link: '/',
    bold: true,
    check: true,
  },
  {
    label: 'colourLabel',
    component: ChooseColour,
    gtmEvent: 'configuratorColour',
  },
  {
    label: 'packsLabel',
    component: ChoosePack,
    gtmEvent: 'configuratorPacks',
    packs: true,
  },
  {
    label: 'accessoriesLabel',
    component: ChooseAccessories,
    accessories: true,
    gtmEvent: 'configuratorAccessories',
  },
  {
    label: 'bikeSummaryLabel',
    component: SummaryActions,
    additionalProps: {
      desktopOnly: true,
    },
    gtmEvent: 'configuratorSummary',
  },
];

export default steps;
